import { Reveal } from "./Reveal";
import { REVIEWS } from "@/lib/data";
import { Star, BadgeCheck } from "lucide-react";

export function Reviews() {
  return (
    <section id="reviews" data-testid="customer-reviews" className="border-y border-white/10 bg-[#0e131f]">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:py-32">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400/90">4.9 / 5 — 4,800+ Better Sleepers</p>
          <h2 className="font-display mt-3 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Nights already transformed
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={(i % 3) * 0.1}>
              <figure data-testid={`review-card-${i}`} className="flex h-full flex-col rounded-3xl border border-white/10 bg-[#131a29] p-7 transition-colors hover:border-white/20">
                <div className="flex text-amber-400">
                  {[...Array(5)].map((_, s) => <Star key={s} className="h-4 w-4 fill-current" />)}
                </div>
                <figcaption className="font-display mt-4 text-lg font-semibold text-white">"{r.title}"</figcaption>
                <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-slate-400">{r.text}</blockquote>
                <div className="mt-5 flex items-center gap-2 text-sm">
                  <span className="font-semibold text-slate-200">{r.name}</span>
                  <span className="text-slate-500">· {r.loc}</span>
                  <span className="ml-auto flex items-center gap-1 text-xs text-emerald-400">
                    <BadgeCheck className="h-3.5 w-3.5" /> Verified
                  </span>
                </div>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
